export default "__VITE_ASSET__B$pun_o___"